import { Outlet } from "@tanstack/react-router";

/**
 * Policies layout page - same structure as integrations (Integrations.tsx).
 * Owns the pageContainer + contentWrapper.
 */
export function Policies() {
  return (
    <div className="Policies-pageContainer">
      <div className="Policies-contentWrapper flex flex-col flex-1 overflow-hidden min-h-0">
        <Outlet />
      </div>
    </div>
  );
}
